
export type InitSubscriptionSession200 = {
  message?: string;
  sessionId?: string;
  success?: boolean;
  userId?: string;
};
